export const draftDialogAllSelector = (state) =>
  state?.draftDialogReducer?.draftDialogAll;
export const draftDialogOpenAddSelector = (state) =>
  state?.draftDialogReducer?.draftDialogOpenAdd;
export const draftDialogOpenEditSelector = (state) =>
  state?.draftDialogReducer?.draftDialogOpenEdit;
export const draftDialogSelectedSelector = (state) =>
  state?.draftDialogReducer?.draftDialogSelected;
export const draftDialogSearchSelector = (state) =>
  state?.draftDialogReducer?.draftDialogSearch;
export const draftDialogEditCardSelector = (state) =>
  state?.draftDialogReducer?.draftDialogEditCard;

//
export const draftDialogDetailSelector = (state) =>
  state?.draftDialogReducer?.draftDialogDetail;
export const draftDialogOpenDenySelector = (state) =>
  state?.draftDialogReducer?.draftDialogOpenDeny;
export const draftDialogOpenWarnSelector = (state) =>
  state?.draftDialogReducer?.draftDialogOpenWarn;
export const draftDialogOpenForwardSelector = (state) =>
  state?.draftDialogReducer?.draftDialogOpenForward;
//

export const draftDialogAudioUrlSelector = (state) =>
  state?.draftDialogReducer?.draftDialogAudioUrl;
export const draftDialogPlaySelector = (state) =>
  state?.draftDialogReducer?.draftDialogPlay;
export const draftDialogSecondSelector = (state) =>
  state?.draftDialogReducer?.draftDialogSecond;
export const draftDialogKickSelector = (state) =>
  state?.draftDialogReducer?.draftDialogKick;
export const draftDialogOpenAdvance = (state) =>
  state?.draftDialogReducer?.draftDialogOpenAdvance;
export const draftDialogEditorDataSelector = (state) =>
  state?.draftDialogReducer?.draftDialogEditorData;
export const draftDialogEditorEditSelector = (state) =>
  state?.draftDialogReducer?.draftDialogEditorEdit;
//
export const draftDialogSpeakerColor = (state) =>
  state?.draftDialogReducer?.draftDialogSpeakerColor;
export const draftDialogSpeakerName = (state) =>
  state?.draftDialogReducer?.draftDialogSpeakerName;
export const draftDialogAdvanceScale = (state) =>
  state?.draftDialogReducer?.draftDialogAdvanceScale;
export const draftDialogAdvanceSelected = (state) =>
  state?.draftDialogReducer?.draftDialogAdvanceSelected;
export const draftDialogAdvanceUndo = (state) =>
  state?.draftDialogReducer?.draftDialogAdvanceUndo;
export const draftDialogAdvanceSave = (state) =>
  state?.draftDialogReducer?.draftDialogAdvanceSave;
//
export const draftDialogMergeRawSelector = (state) =>
  state?.draftDialogReducer?.draftDialogMergeRaw;
export const draftDialogMergeSelector = (state) =>
  state?.draftDialogReducer?.draftDialogMerge;
export const draftDialogSpeakersSelector = (state) =>
  state?.draftDialogReducer?.draftDialogSpeakers;
export const draftDialogSpeakersRawSelector = (state) =>
  state?.draftDialogReducer?.draftDialogSpeakersRaw;
export const draftDialogCommentsSelector = (state) =>
  state?.draftDialogReducer?.draftDialogComments;
